export const TEXTING_UNREAD_COUNT_CHANGED_EVENT = "texting-unread-count-changed";

export const notifyTextingUnreadCountChanged = () => {
  window.dispatchEvent(new Event(TEXTING_UNREAD_COUNT_CHANGED_EVENT));
};
